export default __webpack_public_path__ + "static/media/feedImg.5013d43e.png";